// Shared with GlobalDocumentPreviewModal — renders a policy section's markdown-ish content
// (### headings, "- " bullets, **bold**) the same way it was rendered inline in PoliciesPage.
const renderPolicyContent = text => {
  if (!text) return null;
  return text
    .split("\n")
    .map((line, i) => {
      if (line.startsWith("### ")) {
        return (
          <h3 key={i} className="text-[15px] font-bold text-[#0C0D17] mt-5 mb-2 first:mt-0">
            {line.slice(4)}
          </h3>
        );
      }
      if (line.startsWith("- ")) {
        const parts = line.slice(2).split(/\*\*(.*?)\*\*/g);
        return (
          <li key={i} className="text-[13px] text-[#4A4A4A] leading-relaxed ml-4 list-disc">
            {parts.map((p, j) => (j % 2 === 1 ? <strong key={j}>{p}</strong> : p))}
          </li>
        );
      }
      if (line.trim() === "") return null;
      const parts = line.split(/\*\*(.*?)\*\*/g);
      return (
        <p key={i} className="text-[13px] text-[#4A4A4A] leading-relaxed">
          {parts.map((p, j) => (j % 2 === 1 ? <strong key={j}>{p}</strong> : p))}
        </p>
      );
    })
    .filter(Boolean);
};

export default renderPolicyContent;
